import { useState } from "react";
import { URLS } from "../../utils/url";
import ApiFetch from "../../services/api.fetch";
import { UnsubscribeEventValues } from "../interfaces/ApiInterface";

export const useUnsubscribeEvent = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const unsubscribeEvent = async (userId: number, eventId: number) => {
    try {
      setLoading(true);
      await ApiFetch.httpGet(
        URLS.get.events.withdraw.unsubscribeEvent(userId, eventId),
      );
    } catch (err) {
      setError({
        message: "Something went wrong",
        status: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const values: UnsubscribeEventValues = {
    unsubscribeEvent,
    loading,
    error,
  };
  return values;
};
